<script>
import { useAppStore } from "@/store/modules/app";
import { mapState } from "pinia";

export default {
  name: "MainMenu",
  data() {
    return {
      showSubmenu: false,
      menuItems: {
        left: [
          {name: 'Задачи', code: 'tasks', link: '#/tasks', icon: 'tasks'}
        ],
        right: [
          {name: 'Проекты', code: 'projects', link: '#/projects', icon: 'projects'}
          //{name: 'Настройки', code: 'settings', link: '#/settings', icon: 'settings'},
          //{name: 'Профиль', code: 'profile', link: '#/profile', icon: 'user'}
        ]
      }
    }
  },
  methods: {
    toggleSubmenu () {
      this.showSubmenu = !this.showSubmenu
    },
    isActive (routeName) {
      return this.$route.name === routeName;
    }
  },
  computed: {
    ...mapState(useAppStore, ['userRole'])
  }
}
</script>

<template>
  <nav class="footer__nav">
    <a v-for="(item, index) in menuItems.left" :key="'left-' + index" :href="item.link" class="footer__nav-item" :class="{ 'footer__nav-item--active': isActive(item.code) }">
      <!--<svg class="icon">
        <use :href="'img/svgsprite/sprite.symbol.svg#icon-' + item.icon" xmlns:xlink="http://www.w3.org/1999/xlink"></use>
      </svg>-->
      <i class="pi pi-check-square" style="font-size: 1.43rem"></i>
      <span class="text-caption">{{item.name}}</span>
    </a>
    <div class="footer__nav-item">
      <div class="footer__nav-btn-wrap">
        <button class="footer__nav-btn" :class=" { 'footer__nav-btn--rotate': showSubmenu } " @click="toggleSubmenu"></button>
      </div>
      <ul class="footer__submenu" :class="{ 'footer__submenu--active': showSubmenu }">
        <li class="footer__submenu-item">
          <a href="#/tasks/add" class="footer__submenu-link" @click="toggleSubmenu">Задача</a>
        </li>
        <li v-if="userRole !== 'client'" class="footer__submenu-item">
          <a href="#/projects/add" class="footer__submenu-link" @click="toggleSubmenu">Проект</a>
        </li>
      </ul>
    </div>
    <a v-for="(item, index) in menuItems.right" :key="'right-' + index" :href="item.link" class="footer__nav-item" :class="{ 'footer__nav-item--active': isActive(item.code) }">
      <!--<svg class="icon">
        <use :href="'img/svgsprite/sprite.symbol.svg#icon-' + item.icon" xmlns:xlink="http://www.w3.org/1999/xlink"></use>
      </svg>-->
      <i class="pi pi-folder" style="font-size: 1.43rem"></i>
      <span class="text-caption">{{item.name}}</span>
    </a>
  </nav>
</template>